import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50e0a4ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50e0a4ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0a4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e0a4ac')) {
      api.createRecord('50e0a4ac', component.options)
    } else {
      api.reload('50e0a4ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50e0a4ac&scoped=true", function () {
      api.rerender('50e0a4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cost/index.vue"
export default component.exports